import { classMap } from "lit/directives/class-map.js";
import { when } from "lit/directives/when.js";
import { InternalElement } from "../lib/internal-element.js";
import { css, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DescriptorList = class extends InternalElement {
  render() {
    var _a;
    return html`
      <section id="descriptors">
        ${when((_a = this.quote) == null ? void 0 : _a.product.descriptors, () => {
      var _a2;
      return html`
          <div class=${`descriptor-list ${classMap({ declined: this.declined })}`}>
            ${(_a2 = this.quote) == null ? void 0 : _a2.product.descriptors.map((descriptor) => html`
              <div class="descriptor-item">
                <div class="icon"></div>
                <div>${unsafeHTML(descriptor)}</div>
              </div>
            `)}
          </div>
        `;
    })}
      </section>
    `;
  }
};
DescriptorList.styles = css`
    #descriptors h4 {
      margin: 4px 0 4px 0;
    }

    #descriptors .descriptor-list {
      display: inline-flex;
      flex-direction: column;
      gap: var(--default-vi-descriptors-spacing-y);
    }
  
    #descriptors .descriptor-list .descriptor-item {
      display: flex;
      align-items: flex-start;
      padding: 3px 3px 3px 0;
      font-family: var(--default-vi-font-family);
      gap: var(--default-vi-descriptors-spacing-x);
    }
  
    #descriptors .descriptor-list .descriptor-item .icon {
      scale: var(--default-vi-checkmark-scale);
      max-width: 24px;
      min-width: 24px;
      height: 24px;
      line-height: 1.6rem;
      mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtNiwxMmMzLjMxLDAsNi0yLjY5LDYtNlM5LjMxLDAsNiwwLDAsMi42OSwwLDZzMi42OSw2LDYsNlptMi41NC03LjE1Yy4yNi0uMjkuMjMtLjczLS4wNi0uOTktLjI5LS4yNi0uNzMtLjIzLS45OS4wNmwtMi40LDIuNy0uNjQtLjU5Yy0uMjgtLjI2LS43My0uMjQtLjk5LjA0LS4yNi4yOC0uMjQuNzMuMDQuOTlsMS4wMS45NGMuMzcuMzQuOTUuMzEsMS4yOC0uMDZsMi43NC0zLjA4WiIvPgo8L3N2Zz4=");
      -webkit-mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtNiwxMmMzLjMxLDAsNi0yLjY5LDYtNlM5LjMxLDAsNiwwLDAsMi42OSwwLDZzMi42OSw2LDYsNlptMi41NC03LjE1Yy4yNi0uMjkuMjMtLjczLS4wNi0uOTktLjI5LS4yNi0uNzMtLjIzLS45OS4wNmwtMi40LDIuNy0uNjQtLjU5Yy0uMjgtLjI2LS43My0uMjQtLjk5LjA0LS4yNi4yOC0uMjQuNzMuMDQuOTlsMS4wMS45NGMuMzcuMzQuOTUuMzEsMS4yOC0uMDZsMi43NC0zLjA4WiIvPgo8L3N2Zz4=");
      background: var(--default-vi-descriptors-checkmark-accept-color);
    }
  
    #descriptors .descriptor-list.declined .descriptor-item .icon {
      mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtMTIsNmMwLDMuMzEtMi42OSw2LTYsNlMwLDkuMzEsMCw2LDIuNjksMCw2LDBzNiwyLjY5LDYsNlptLTMuNzQtMi4yNmMuMjcuMjcuMjcuNzIsMCwuOTlsLTEuMjcsMS4yNywxLjI3LDEuMjdjLjI3LjI3LjI3LjcyLDAsLjk5LS4yNy4yNy0uNzIuMjctLjk5LDBsLTEuMjctMS4yNy0xLjI3LDEuMjdjLS4yNy4yNy0uNzIuMjctLjk5LDAtLjI3LS4yNy0uMjctLjcyLDAtLjk5bDEuMjctMS4yNy0xLjI3LTEuMjdjLS4yNy0uMjctLjI3LS43MiwwLS45OS4yNy0uMjcuNzItLjI3Ljk5LDBsMS4yNywxLjI3LDEuMjctMS4yN2MuMjctLjI3LjcyLS4yNy45OSwwWiIvPgo8L3N2Zz4=");
      -webkit-mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtMTIsNmMwLDMuMzEtMi42OSw2LTYsNlMwLDkuMzEsMCw2LDIuNjksMCw2LDBzNiwyLjY5LDYsNlptLTMuNzQtMi4yNmMuMjcuMjcuMjcuNzIsMCwuOTlsLTEuMjcsMS4yNywxLjI3LDEuMjdjLjI3LjI3LjI3LjcyLDAsLjk5LS4yNy4yNy0uNzIuMjctLjk5LDBsLTEuMjctMS4yNy0xLjI3LDEuMjdjLS4yNy4yNy0uNzIuMjctLjk5LDAtLjI3LS4yNy0uMjctLjcyLDAtLjk5bDEuMjctMS4yNy0xLjI3LTEuMjdjLS4yNy0uMjctLjI3LS43MiwwLS45OS4yNy0uMjcuNzItLjI3Ljk5LDBsMS4yNywxLjI3LDEuMjctMS4yN2MuMjctLjI3LjcyLS4yNy45OSwwWiIvPgo8L3N2Zz4=");
      background: var(--default-vi-descriptors-checkmark-decline-color);
    }
  `;
__decorateClass([
  property({ type: Boolean })
], DescriptorList.prototype, "declined", 2);
DescriptorList = __decorateClass([
  customElement("descriptor-list")
], DescriptorList);
export {
  DescriptorList
};
